import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: 'login',
    loadChildren: () => import('./login/login.module').then( m => m.LoginPageModule)
  },
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'registration',
    loadChildren: () => import('./registration/registration.module').then( m => m.RegistrationPageModule)
  },
  {
    path: 'reset-password',
    loadChildren: () => import('./reset-password/reset-password.module').then( m => m.ResetPasswordPageModule)
  },
  {
    path: 'home',
    loadChildren: () => import('./menu/menu.module').then( m => m.MenuPageModule)
  },
  {
    path: 'details',
    loadChildren: () => import('./details/details.module').then( m => m.DetailsPageModule)
  },
  {
    path: 'slot-model',
    loadChildren: () => import('./slot-model/slot-model.module').then( m => m.SlotModelPageModule)
  },
  {
    path: 'model-appointments',
    loadChildren: () => import('./model-appointments/model-appointments.module').then( m => m.ModelAppointmentsPageModule)
  },
  {
    path: 'model-search',
    loadChildren: () => import('./model-search/model-search.module').then( m => m.ModelSearchPageModule)
  },
  {
    path: 'model-shoft-appointments',
    loadChildren: () => import('./model-shoft-appointments/model-shoft-appointments.module').then( m => m.ModelShoftAppointmentsPageModule)
  },
  {
    path: 'records-profiles-modal',
    loadChildren: () => import('./records-profiles-modal/records-profiles-modal.module').then( m => m.RecordsProfilesModalPageModule)
  },
  {
    path: 'reports',
    loadChildren: () => import('./reports/reports.module').then( m => m.ReportsPageModule)
  },
  {
    path: 'report-view-modal',
    loadChildren: () => import('./report-view-modal/report-view-modal.module').then( m => m.ReportViewModalPageModule)
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
